var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.622 34.364 H 18.091 c -1.983 0 -3.591 -1.608 -3.591 -3.591 v -5.005 c 0 -1.983 1.608 -3.591 3.591 -3.591 h 47.531 c 1.983 0 3.591 1.608 3.591 3.591 v 5.005 C 69.212 32.756 67.605 34.364 65.622 34.364 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#3478F5",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 59.559 23.229 H 24.153 c -2.118 0 -3.835 1.717 -3.835 3.835 v 46.252 c 0 2.118 1.717 3.835 3.835 3.835 h 35.406 c 2.118 0 3.835 -1.717 3.835 -3.835 V 27.064 C 63.394 24.946 61.677 23.229 59.559 23.229 z M 34.184 67.084 c 0 1.808 -1.48 3.288 -3.288 3.288 c -1.808 0 -3.288 -1.48 -3.288 -3.288 v -25.23 c 0 -1.808 1.48 -3.288 3.288 -3.288 c 1.808 0 3.288 1.48 3.288 3.288 V 67.084 z M 45.144 67.084 c 0 1.808 -1.48 3.288 -3.288 3.288 s -3.288 -1.48 -3.288 -3.288 v -25.23 c 0 -1.808 1.48 -3.288 3.288 -3.288 s 3.288 1.48 3.288 3.288 V 67.084 z M 56.104 67.084 c 0 1.808 -1.48 3.288 -3.288 3.288 s -3.288 -1.48 -3.288 -3.288 v -25.23 c 0 -1.808 1.48 -3.288 3.288 -3.288 s 3.288 1.48 3.288 3.288 V 67.084 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#3478F5",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.5c7e6260fc30e397f03468c63a269ab9.svg";
export { ForwardRef as ReactComponent };